/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:30
 * @LastEditors: yy
 * @LastEditTime: 2019-12-09 10:44:50
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './ExportTitle.css';

const ExportTitle = (props) => {
  return (
    <div className={s.container}>
      <div className={s.titleWrapper}>
        <div className={s.titleRect}>
          {props.children}
        </div>
      </div>
      <div className={s.triangle}></div>
      <div className={s.line}></div>
    </div>
  )
}

export default withStyles(s)(ExportTitle);


// WEBPACK FOOTER //
// src/components/ExportTitle/ExportTitle.js